import React, { Component } from 'react';
import { getDocuments, getProductDocuments, getMatchingProduct, getDocCount } from '../../apis/search';
import LoaderSection from '../components/loader-section.jsx';
import DocumentCard from '../components/document-card.jsx';
import SearchSection from '../components/search-section.jsx';
import Product from '../components/product-item.jsx';
import Filters from '../components/filters.jsx';
import ReactPaginate from 'react-paginate';
import animatedScrollTo from 'animated-scroll-to';
import { getUrlParams } from '../../utils/';
import toast from '../../components/toast';
import { transformBytes } from '../../utils/';

class DownloadsLibrary extends Component {
    constructor(props) {
        super(props);
     
        this.state = {
            documentItems: [],
            isLoading: false,
            pagePath: location.pathname,
            q: '',
            totalRecords: 0,
            directProduct: {},
            productDocs: [],
            pageSize: 12,
            page: 1,
            showDocs: true,
            docTypes: {},
            showFilters: true,
            categoryList: [],
            directMatch: false,
            firstLoad: true,
            docCount: {}
        }

        this.loadDocuments = this.loadDocuments.bind(this);
        this.loadDirectMatch = this.loadDirectMatch.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getUrl = this.getUrl.bind(this);
        this.searchInput = React.createRef();
        this.resetSearch = this.resetSearch.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.getDocTypeCount = this.getDocTypeCount.bind(this);
    }

    componentDidMount() {
        const docTypes = this.props.docCodes;
        this.getDocTypeCount();
        let params = getUrlParams();
        let pageNum, q;

        if (Object.keys(params).length) {
            pageNum = params.page && params.page !== '1' ? params.page : 1;
            q = params.q ? params.q : '';
            this.setState({
                page: pageNum,
                docTypes: docTypes,               
                categoryList: [],
                q: q
            }, () => {
                this.loadDocuments(this.state.categoryList, true);
            });
        } else {
            this.setState({
                docTypes: docTypes,
                categoryList: []
            }, () => { this.loadDocuments(this.state.categoryList, true); });

        }

        window.addEventListener('popstate', e => {  
            let params = getUrlParams();
            let pageNum;
            let q;
            
            if (Object.keys(params).length) {
                this.cleanUpState();
                pageNum = params.page && params.page !== '1' ? params.page : 1;
                q = params.q && params.q !== '' ? params.q : '';
                this.setState({
                    page: pageNum,
                    q: q,
                    categoryList: []
                }, () => {
                     
                    this.loadDirectMatch(false);
                });
            } else {
                this.setState({ page: 1 }, () => {
                        this.resetSearch(e);                  
                   // this.loadDirectMatch(false);
                });
            }
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.cleanUpState();
        this.setState({ q: this.searchInput.current.value }, () => {
            this.loadDirectMatch();
        });
    }

    resetFilters() {
        Array.from(document.querySelectorAll('.document-checkbox')).map((item, key) => {
            if (item.checked) item.checked = false;
        });
    }

    resetSearch(e) {
        e.preventDefault();
        this.cleanUpState();
        this.setState({ q: '' }, () => {
            this.loadDirectMatch(false);
        });
        this.resetFilters();
        this.searchInput.current.focus();
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    //logic for filters
    onCheckBoxChange(e) {
        const target = e.target,
            isChecked = target.checked,
            name = target.name;
        let categories = [...this.state.categoryList];

        if (isChecked) {
            categories.push(name);
            this.setState({
                showDocs: true,
                categoryList: categories
            }, () => {
                this.loadDocuments(categories);
            });
        }
        else {
            const filtered = categories.filter(item => item !== name);

            this.setState({
                categoryList: filtered
            }, () => {
                this.loadDocuments(filtered);
            });
        }
    }

    cleanUpState() {
        this.setState({
            documentItems: [],
            directProduct: {},
            productDocs: [],
            page: 1
        });
    }

    pages() {
        return Math.ceil(this.state.totalRecords / this.state.pageSize);
    }

    showPagination() {
        return this.state.totalRecords > this.state.pageSize;
    }

    handlePageClick(data) {
        this.setState({
            page: data.selected + 1
        }, () => {
            this.loadDocuments(this.state.categoryList, true);
            animatedScrollTo(document.querySelector('.documents-search-section'));
        });
    }

    getUrl() {
        const filters = {
            q: this.state.q,
            page: this.state.page
        };
        const baseUrl = `${window.location.pathname}`,
            params = [];
        for (const key in filters) {
            let val = filters[key];
            if (((key === 'page' && val > 1) || key !== 'page')) {
                if (typeof val === 'string') val = val.toLowerCase();
                if (val) params.push(`${key}=${encodeURIComponent(val)}`);
            }
        }

        return `${baseUrl}${params.length ? '?' : ''}${params.join('&')}`;
    }

    getDocTypeCount() {
        let q = this.state.q;
        if (this.state.q === '') q = '*';

        let params = {
            q: q
        }

        getDocCount(params)
            .then(data => {
                this.setState
                    ({
                        docCount: data
                    })
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });
    }

    //check if direct product match or send to get search related documents
    loadDirectMatch(pushState = true) {
        let q = this.state.q;
        if (!this.state.q) q = '*';
        this.setState({
            isLoading: true,
            showFilters: true,
            showDocs: true,
            // categoryList: [],
            directMatch: false
        });

        const params = {
            q: q
        }       

        this.setState({ productDocs: [] });

        const getProductMatch = getMatchingProduct(params)
            .then(data => {
                if (data) {
                    if (pushState && !this.state.firstLoad) history.pushState(null, document.title, this.getUrl());
                    toast.success('We found a matching product');
                    this.setState({
                        directProduct: data,
                        directMatch: true,
                        firstLoad: false
                    });

                    return data;

                } else {
                    this.loadDocuments(this.state.categoryList, pushState);
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });

        const getProductDocs = getProductDocuments(params)
            .then(data => {
                if (data) {
                    this.setState({
                        productDocs: data
                    });
                    return data;
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });

        Promise.all([getProductMatch, getProductDocs])
            .then(() => {
                

                this.setState({
                    isLoading: false
                });
            });
    }

    //load search related documents if no direct match found
    loadDocuments(category, pushState) {
        console.log(category);
        let q = this.state.q;

        if (!this.state.q) q = '*';

        this.setState({
            isLoading: true
        });
        if (pushState && !this.state.firstLoad) history.pushState(null, document.title, this.getUrl());
        const params = {
            q: q,
            page: this.state.page,
            pageSize: this.state.pageSize,
            type: category
        };

        this.getDocTypeCount();

        getDocuments(params)
            .then(data => {
                this.setState({
                    documentItems: data.records,
                    totalRecords: data.totalRecords,
                    isLoading: false,
                    showDocs: true,
                    firstLoad: false
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });
    }

    render() {
        let documents,
            loader,
            productDocs,
            documentList,
            showPagination,
            showFilters,
            searchClearBtn;

        if (this.state.isLoading) {
            loader = <LoaderSection show={true} />;
        }

        const pagination = <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.pages()}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={this.state.page - 1}
        />;

        if (this.showPagination()) {
            showPagination = pagination;
        }

        //section with components used with a direct product match
        documentList = <h5>{this.props.noDocs}</h5>;

        if (this.state.productDocs.length) {
            documentList = this.state.productDocs.map(
                (document, index) => (
                    <DocumentCard key={index} colClass="media-card-container" {...document} />
                ));
        }

        if (this.state.showFilters) {
            showFilters =
                <Filters q={this.state.q} showSearch={false}>
                    <div className="filter-accordion-content">
                        {Object.entries(this.state.docTypes).map(([key, value], index) => {
                            const count = Object.entries(this.state.docCount).filter(item => item[0] === key);
                            const finalCount = count[0];
                            return <div key={key}>
                                <input type="checkbox" className="custom-checkbox square" id={index} ref={this.filterBox} name={key} value={value} autocomplete="off" onChange={this.onCheckBoxChange} />
                                <label htmlFor={index}>
                                    <span>{value}</span>
                                    {finalCount && finalCount.length &&
                                        <span className="dull">({finalCount[1]})</span>
                                    }
                                </label>
                            </div>
                        })}
                    </div>
                </Filters>;
        } else {
            showFilters = <div></div>;
        }

        if (Object.keys(this.state.directProduct).length && this.state.directMatch) {
            productDocs =
                <SearchSection className="documents-match-section" titleBold="Direct Product Match">
                    {loader}
                    <div className="row">
                        <Product colClass="col-lg-3" {...this.state.directProduct} />
                        <div className="col-lg-9">
                            {documentList}
                        </div>
                    </div>
                </SearchSection>;
        }

        const searchTitle = !this.state.q ? 'All Product Documents' : `Search Results for "${this.state.q}"`;
        if (this.state.q) {
            searchClearBtn = <button className="search-drawer-btn document-reset" type="button" onClick={this.resetSearch}>x</button>;
        }

        //product documents not related to a specific product match
        if (this.state.documentItems.length >= 0 && this.state.showDocs && !this.state.directMatch) {
            documents =
                <div className="documents-search-section">
                    <div className="row">
                        <div className="col-lg-3">
                            {showFilters}
                        </div>
                        <div className="col-lg-9">
                            <h4 className="download-quantity">{searchTitle} ({`${this.state.totalRecords} found`})</h4>
                            {loader}
                            {this.state.documentItems.map(
                                (document, index) => (
                                    <DocumentCard key={index} colClass="media-card-container" {...document} />
                                ))}
                            {showPagination}
                        </div >
                    </div>
                </div>;
        }

        return (
            <div>
                <div className="row download-input">
                    <div className="col-lg-7 col-md-6">
                        <p className="download-description download-description-bold">
                            {this.props.searchMsg}
                        </p>
                    </div>
                    <form action={this.state.pagePath} method="get" onSubmit={this.onSubmit} className="col-lg-4 col-md-6">
                        <div className="downloads-input-box">
                            <label className="sr-only" htmlFor="search-field">Search</label>
                            <input ref={this.searchInput} className="search-drawer-input document-search-input" value={this.state.q} id="search-field" type="text" name="q" placeholder="Search..." required autoCapitalize="none" autoCorrect="off" autoFocus="true" />
                            {searchClearBtn}
                            <button className="search-drawer-btn document-search">
                                <img src="/img/search-glass.svg" alt="Search" height="40" width="40" />
                                <span className="sr-only">Search</span>
                            </button>
                        </div>
                    </form>
                </div>
                {productDocs}
                {documents}
            </div>
        );
    }
}

export default DownloadsLibrary;